/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
import { UserState } from "../user-state";
import { UserInfo } from "src/app/core/models/entites/userInfo";
import {
    RESET_AUTH_ERROR_MESSAGE,
    USER_LOGIN,
    USER_LOGIN_FAILED,
    USER_LOGIN_SUCCESS,
    USER_REGISTRATION,
    USER_REGISTRATION_FAILED,
    USER_REGISTRATION_RESULT,
} from "../actions/user-authentification.actions";
import { SAVE_USER_INFO, UPDATE_POINTS_COUNT } from "../actions/user.actions";

const getUserFeatureState = createFeatureSelector<UserState>("user");

export const selectUserBalanceInMBC = createSelector(
    selectLocalStorageValue,
    (userInfo: UserInfo) => userInfo && userInfo.pointsCount
);

export const selectUserBarCode = createSelector(
    selectLocalStorageValue,
    (userInfo: UserInfo) => userInfo && userInfo.barCode
);

export const selectClientId = createSelector(
    selectLocalStorageValue,
    (userInfo: UserInfo) => userInfo && userInfo.client_ID
);

export const selectUserMaxbetId = createSelector(
    selectLocalStorageValue,
    (userInfo: UserInfo) => userInfo && userInfo.maxbet_ID
);

export const selectUserInfo = createSelector(
    selectLocalStorageValue,
    (userInfo: UserInfo) => userInfo
);

export const selectUserFullName = createSelector(
    selectLocalStorageValue,
    (userInfo: UserInfo) => userInfo && (userInfo.firstName + " " + userInfo.lastName)
);

export const selectAuthError = createSelector(
    getUserFeatureState,
    (state: UserState) => state && state.authValidationError
);

const initialState: UserState = {
    user: new UserInfo("", "", "", "", "", "", "", 0, 0, "", "", 0),
    authValidationError: "",
};

export const userReducer = createReducer<UserState>(
    initialState,
    on(UPDATE_POINTS_COUNT, (state: UserState, { pointsCount }): UserState => {
        const userInfo = selectLocalStorageValue();
        userInfo.pointsCount = pointsCount;
        sessionStorage.setItem("UserInfo", JSON.stringify(userInfo));
        return {
            ...state,
        };
    }),
    on(SAVE_USER_INFO, (state: UserState, { modifiedUser }): UserState => {
        const userInfo = selectLocalStorageValue();
        userInfo.phone = modifiedUser.phone;
        sessionStorage.setItem("UserInfo", JSON.stringify(userInfo));
        return {
            ...state,
        };
    }),
    on(USER_LOGIN_SUCCESS, (state: UserState, { loggedUser }): UserState => {
        sessionStorage.setItem("UserInfo", JSON.stringify(loggedUser));
        return {
            ...state,
            user: loggedUser,
        };
    }),
    on(USER_LOGIN_FAILED, (state: UserState, { response }): UserState => {
        return {
            ...state,
            authValidationError: response.status === 0 ? "Održavanje u toku, molimo te da pokušaš kasnije." : response.error.message
        };
    }),
    on(USER_LOGIN, (state: UserState): UserState => {
        return {
            ...state,
            authValidationError: ""
        };
    }),
    on(USER_REGISTRATION_RESULT, (state: UserState, { response }): UserState => {
        return {
            ...state,
            authValidationError: response.status === 0 ? "Održavanje u toku, molimo te da pokušaš kasnije." : response.message
        };
    }),
    on(USER_REGISTRATION_FAILED, (state: UserState, { response }): UserState => {
        return {
            ...state,
            authValidationError: response.status === 0 ? "Održavanje u toku, molimo te da pokušaš kasnije." : response.error
        };
    }),
    on(USER_REGISTRATION, (state: UserState): UserState => {
        return {
            ...state
        };
    }),
    on(RESET_AUTH_ERROR_MESSAGE, (state: UserState): UserState => {
        return {
            ...state,
            authValidationError: ""
        };
    }),
);

function selectLocalStorageValue(): UserInfo {
    const userInfo = JSON.parse(sessionStorage.getItem("UserInfo")!) as UserInfo;
    return userInfo;
}
